import { Box, Button, CircularProgress, Typography } from "@mui/material";
import PaymentDialog from "../payment/PaymentDialog";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { useEffect, useState } from "react";
import { darken } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import WarningReviewLimitedDialog from "./WarningReviewLimitedDialog";
import { WARNING_REVIEW_ALLOWED } from "@/graphql/mutations/warning";
import { useMutation } from "@apollo/client";
import useUploadReceipt from "../payment/hooks/useUploadReceipt";
import WarningReviewContainer from "../review/WarningReviewContainer";
import { errorToast } from "@/utils/toasts";

export default function Warning({ warning, configs }) {
    const [open, setOpen] = useState(false);
    const [openBottomsheet, setOpenBottomsheet] = useState(false);
    const [openLimitedDialog, setOpenLimitedDialog] = useState(false);
    const [limit, setLimit] = useState(0);
    const [remaining, setRemaining] = useState(0);

    const { openParentDialog } = useUploadReceipt();

    useEffect(() => {
        if (openParentDialog) {
            setOpen(true);
        }
    }, [openParentDialog]);

    let text = "";
    if (warning?.reason == "LESSON_ABSENCE") {
        text = `متاسفانه به دلیل تاخیر بیشتر از یک روز در مشاهده درس فعلی ، حساب کاربری شما مسدود شده است و امکان شرکت در آزمون و مشاهده درس های بعدی وجود ندارد. `;
    } else if (warning?.reason == "EXAM_ABSENCE") {
        text = `متاسفانه به دلیل شرکت نکردن به موقع در آزمون ، حساب کاربری
        شما مسدود شده است و امکان شرکت در آزمون و مشاهده درس های
        بعدی وجود ندارد.`;
    } else if (warning?.reason == "EXAM_FAILURE") {
        text = `متاسفانه به دلیل کسب نکردن نمره قبولی پس از دو مرتبه شرکت در آزمون ، حساب
        کاربری شما مسدود شده است و امکان شرکت در آزمون و مشاهده درس های
        بعدی وجود ندارد.`;
    }

    const [warningReviewAllowed, { loading: warningReviewAllowedLoading }] =
        useMutation(WARNING_REVIEW_ALLOWED);

    return (
        <>
            <Box sx={{ margin: "10px 0" }}>
                <Alert
                    severity="error"
                    sx={{
                        backgroundColor: "red",
                        color: "#fff",
                        fontWeight: "bold",
                        svg: { color: "#fff" },
                    }}
                >
                    <AlertTitle>اخطار</AlertTitle>

                    <Grid
                        container
                        display={"flex"}
                        flexDirection={"column"}
                        rowGap={1}
                    >
                        <Grid item>
                            <Typography
                                sx={{
                                    color: "#ffffff",
                                    fontWeight: "bold",
                                    fontSize: "0.9rem",
                                }}
                            >
                                {text}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Typography
                                sx={{
                                    color: "#ffffff",
                                    fontWeight: "bold",
                                    fontSize: "0.9rem",
                                }}
                            >
                                با پرداخت جریمه مقرر شده می توانید حساب کاربری
                                تان را رفع مسدودیت کنید.
                            </Typography>
                        </Grid>

                        <Grid
                            item
                            display={"flex"}
                            flexDirection={{
                                xs: "column",
                                md: "row",
                            }}
                            justifyContent={"flex-end"}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    ":hover": {
                                        backgroundColor: darken("#fff", 0.1),
                                    },
                                    fontWeight: "bold",
                                    minWidth: "150px",
                                    width: { xs: "100%", md: "unset" },
                                }}
                                onClick={() => setOpen(true)}
                            >
                                پرداخت جریمه
                            </Button>

                            <Box
                                sx={{
                                    height: { xs: "12px", md: "unset" },
                                    width: { xs: "unset", md: "12px" },
                                }}
                            />

                            <Button
                                variant="outlined"
                                size="small"
                                sx={{
                                    color: "#fff",
                                    fontWeight: "bold",
                                    border: "2px solid #ffffff !important",
                                    minWidth: "150px",
                                    width: { xs: "100%", md: "unset" },
                                    ":hover": {
                                        backgroundColor: darken("#ff0000", 0.1),
                                    },
                                }}
                                disabled={warningReviewAllowedLoading}
                                onClick={() => {
                                    warningReviewAllowed().then((res) => {
                                        const errorMessage =
                                            res?.errors?.[0]?.message ?? null;

                                        if (errorMessage) {
                                            errorToast(errorMessage);
                                        } else if (
                                            res?.data?.warningReviewAllowed?.ok
                                        ) {
                                            setRemaining(
                                                res?.data?.warningReviewAllowed
                                                    ?.remaining ?? 0
                                            );
                                            setOpenBottomsheet(true);
                                        } else {
                                            setLimit(
                                                res?.data?.warningReviewAllowed
                                                    ?.limit ?? 0
                                            );
                                            setOpenLimitedDialog(true);
                                        }
                                    });
                                }}
                            >
                                {warningReviewAllowedLoading ? (
                                    <CircularProgress size="1.5rem" />
                                ) : (
                                    "درخواست بازبینی جریمه"
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                </Alert>
            </Box>

            <PaymentDialog
                title="پرداخت جریمه"
                open={open}
                handleClose={() => setOpen(false)}
                warning={warning}
                configs={configs}
            />

            {openBottomsheet && (
                <WarningReviewContainer
                    remaining={remaining}
                    onClose={() => setOpenBottomsheet(false)}
                    onOpenPaymentDialog={() => setOpen(true)}
                    warning={warning}
                />
            )}

            <WarningReviewLimitedDialog
                open={openLimitedDialog}
                limit={limit}
                onClose={() => setOpenLimitedDialog(false)}
            />
        </>
    );
}
